import { Award, BarChart3, BookOpen, Bot, Clock3, LogOut, Menu, PlusCircle, Settings, Sparkles, UserCog, UsersRound, X } from "lucide-react";
import { useState, type ReactNode } from "react";
import { Link, useLocation } from "../lib/router";
import { useAuth } from "../contexts";
import { PWAInstallButton } from "./PWAInstallButton";

const navigation = [
  { href: "/dashboard", label: "Visão geral", icon: BarChart3 },
  { href: "/new-session", label: "Nova conversa", icon: PlusCircle },
  { href: "/history", label: "Histórico", icon: Clock3 },
  { href: "/progress", label: "Meu progresso", icon: BookOpen },
  { href: "/gamification", label: "Fases e prêmios", icon: Award },
  { href: "/settings", label: "Preferências", icon: Settings }
];

export function Layout({ children, title, subtitle, action }: { children: ReactNode; title: string; subtitle?: string; action?: ReactNode }) {
  const { user, logout } = useAuth();
  const [location, navigate] = useLocation();
  const [open, setOpen] = useState(false);
  const items = user?.role === "admin" ? [...navigation, { href: "/admin/scenarios", label: "Cenários", icon: UserCog }, { href: "/admin/users", label: "Usuários", icon: UsersRound }] : navigation;
  const close = () => setOpen(false);
  const exit = async () => { await logout(); navigate("/login"); };
  return <div className="app-shell">
    <aside className={`sidebar ${open ? "open" : ""}`}>
      <div className="brand"><div className="brand-icon"><Bot size={26} /></div><div><strong>LinguaHome</strong><span>AI Language Tutor</span></div><button className="icon-button mobile-only" onClick={close}><X size={20}/></button></div>
      <nav>{items.map((item) => { const Icon = item.icon; const active = location === item.href || location.startsWith(`${item.href}/`); return <Link key={item.href} href={item.href} onClick={close} className={`nav-item ${active ? "active" : ""}`}><Icon size={19}/><span>{item.label}</span></Link>; })}</nav>
      <div className="sidebar-tip"><Sparkles size={18}/><div><b>Prática diária</b><span>Fale pelo menos 10 minutos para ganhar confiança.</span></div></div>
      <button className="nav-item logout" onClick={exit}><LogOut size={19}/><span>Sair</span></button>
    </aside>
    {open && <div className="backdrop" onClick={close}/>} 
    <main className="main-content">
      <header className="topbar"><button className="icon-button mobile-only" onClick={() => setOpen(true)}><Menu/></button><div className="page-heading"><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div><div className="topbar-actions"><PWAInstallButton compact />{action}<div className="user-chip"><span>{user?.name?.charAt(0).toUpperCase()}</span><div><b>{user?.name}</b><small>{user?.role === "admin" ? "Administrador" : "Estudante"}</small></div></div></div></header>
      <div className="page-content">{children}</div>
    </main>
  </div>;
}
